var sanitizeEmojiValue = function sanitizeEmojiValue(value) {
  return value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
};
var extractIconRenderer = function extractIconRenderer(data, renderers) {
  var prefix = data['atlassian:titlePrefix'];
  if ((prefix === null || prefix === void 0 ? void 0 : prefix['@type']) === 'atlassian:Emoji') {
    var emojiId = sanitizeEmojiValue(prefix['text']);
    var emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
    if (emojiId && emojiRenderer) {
      return function () {
        return emojiRenderer(emojiId);
      };
    }
  }
};
export default extractIconRenderer;